import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db, collection, getDoc, getDocs, query, where, setDoc, doc,} from '../firebase';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { orderBy } from 'firebase/firestore'; // 📌 tout en haut de ton fichier si pas déjà fait
import { writeBatch } from 'firebase/firestore'; // ajoute en haut si pas déjà importé
import { deleteDoc } from 'firebase/firestore'

// Utility to generate a match with two teams and their poolIndex
const generateMatch = (teamA, teamB, poolIndex, phase = "poule", order = 0) => ({
  phase,
  poolIndex,
  order,
  teamA: { name: teamA, score: 0 },
  teamB: { name: teamB, score: 0 },
});



// Individual Match component to handle score input
const MatchScore = ({ match, matchIndex, poolIndex, onScoreChange }) => {
  const handleScoreChange = (teamKey, score) => {
    onScoreChange(poolIndex, matchIndex, teamKey, score);
  };

  return (
    <div className="text-gray-600 bg-white px-4 py-3 rounded-lg shadow-md border">
      <div className="flex justify-between">
        <div>
          <span className="font-semibold text-[#4c2f8e]">{match.teamA.name}</span> vs{' '}
          <span className="font-semibold text-[#4c2f8e]">{match.teamB.name}</span>
        </div>
        <div className="flex space-x-4">
          <div>
            <label>Score {match.teamA.name}:</label>
            <input
              type="number"
              value={match.teamA.score || ''}
              onChange={(e) => handleScoreChange('teamA', parseInt(e.target.value, 10) || 0)}
              className="p-1 border rounded-md w-16"
            />
          </div>
          <div>
            <label>Score {match.teamB.name}:</label>
            <input
              type="number"
              value={match.teamB.score || ''}
              onChange={(e) => handleScoreChange('teamB', parseInt(e.target.value, 10) || 0)}
              className="p-1 border rounded-md w-16"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const TournamentView = () => {
  const { tournamentId } = useParams();
  const [players, setPlayers] = useState([]);
  const [pools, setPools] = useState([]);
  const [matchesByPool, setMatchesByPool] = useState([]);
  const [rankedPools, setRankedPools] = useState([]);
  const [showPools, setShowPools] = useState({});
  const [loading, setLoading] = useState(true);
  const [matchesLoaded, setMatchesLoaded] = useState(false);
  const [generatedPoolKeys, setGeneratedPoolKeys] = useState([]);
  const [finalRanking, setFinalRanking] = useState([]);
  const [forceRegeneration, setForceRegeneration] = useState(false);





  // Fetch players and scores from Firestore
  useEffect(() => {
    const fetchPlayersAndMatches = async () => {
      try {
        const q = collection(db, 'tournament_registrations', tournamentId, 'inscriptions');

        const querySnapshot = await getDocs(q);
        const playersData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPlayers(playersData);

        const scoresRef = doc(db, 'tournaments', tournamentId);

        // Récupérer les matchs depuis Firestore
const matchesColl = collection(db, `tournaments/${tournamentId}/matches`);
const matchesQ = query(
  matchesColl,
  orderBy('poolIndex'),
  orderBy('order')
);
const matchesSnap = await getDocs(matchesQ);

// 🔁 Récupération des finales
const finalesSnap = await getDocs(collection(db, `tournaments/${tournamentId}/matches_finales`));
const finales = finalesSnap.docs.map(doc => ({
  id: doc.id,
  ...doc.data(),
  teamA: doc.data().teamA || { name: "", score: 0 },
  teamB: doc.data().teamB || { name: "", score: 0 },
}));

// 🔁 Récupération des consolations
const consolSnap = await getDocs(collection(db, `tournaments/${tournamentId}/matches_consolation`));
const consolations = consolSnap.docs.map(doc => ({
  id: doc.id,
  ...doc.data(),
  teamA: doc.data().teamA || { name: "", score: 0 },
  teamB: doc.data().teamB || { name: "", score: 0 },
}));


// Récupérer les documents sous forme d'objets
const storedMatches = matchesSnap.docs.map(doc => {
  const data = doc.data();

  const normalizeTeam = (team) =>
    typeof team === 'string'
      ? { name: team, score: 0 }
      : team?.name
      ? team
      : { name: '', score: 0 };

  return {
    id: doc.id, // 👈 on garde l'id pour plus tard
    ...data,
    poolIndex: Number(data.poolIndex ?? 0),
    order: Number(data.order ?? 0),
    teamA: normalizeTeam(data.teamA),
    teamB: normalizeTeam(data.teamB),
  };
});


// Conversion des champs poolIndex et order en nombres
storedMatches.forEach(match => {
  match.poolIndex = Number(match.poolIndex ?? 0);
  match.order = Number(match.order ?? 0);
});
console.log("Matches convertis :", storedMatches);

// Tri manuel par poolIndex puis par order
storedMatches.sort((a, b) => {
  const poolDiff = a.poolIndex - b.poolIndex;
  if (poolDiff !== 0) return poolDiff;
  return a.order - b.order;
});
console.log("Matches triés :", storedMatches);

// Regroupement par poolIndex
const grouped = storedMatches.reduce((acc, match) => {
  if (match.poolIndex == null) return acc;
  if (!acc[match.poolIndex]) acc[match.poolIndex] = [];
  acc[match.poolIndex].push(match);
  return acc;
}, {});

if (finales.length > 0) grouped["finales"] = finales;
if (consolations.length > 0) grouped["consolation"] = consolations;

console.log("Matches groupés par poolIndex :", grouped);
setMatchesByPool(grouped);
// Associer les joueurs à chaque match
for (const key in grouped) {
  grouped[key] = grouped[key].map(match => {
    const normalize = (str) =>
      str?.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    const teamAPlayers = players.filter(p => normalize(p.teamName) === normalize(match.teamA.name));
    const teamBPlayers = players.filter(p => normalize(p.teamName) === normalize(match.teamB.name));

    return {
      ...match,
      teamAPlayers,
      teamBPlayers,
    };
  });
}

setMatchesLoaded(true);


        

      } catch (error) {
        console.error("Error fetching players or matches:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayersAndMatches();
  }, [tournamentId]);

  // Generate pools and matches if no scores are loaded
  useEffect(() => {
    const numericPoolKeys = Object.keys(matchesByPool).filter(k => !isNaN(k));

    if (players.length > 0 && matchesLoaded || forceRegeneration) {
      const alreadyGenerated = numericPoolKeys.every(k => generatedPoolKeys.includes(k));
      if (alreadyGenerated) return;
  
      let newPools = [];
      if (numericPoolKeys.length > 0) {
        const maxPoolIndex = Math.max(...numericPoolKeys.map(k => parseInt(k, 10)));
        for (let i = 0; i <= maxPoolIndex; i++) {
          const poolMatches = matchesByPool[i] || [];
          const teamsInThisPool = new Set();
          poolMatches.forEach(match => {
            if (match?.teamA?.name) teamsInThisPool.add(match.teamA.name);
            if (match?.teamB?.name) teamsInThisPool.add(match.teamB.name);
          });
  
          const normalize = str => str?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          const playersInPool = players.filter(p =>
            [...teamsInThisPool].some(team => normalize(team) === normalize(p.teamName))
          );
  
          newPools.push(playersInPool);
        }
      } else {
        for (let i = 0; i < players.length; i += 4) {
          newPools.push(players.slice(i, i + 4));
        }
      }
  
      setPools(newPools);
      setShowPools(newPools.reduce((acc, _, index) => ({ ...acc, [index]: true }), {}));
      setGeneratedPoolKeys(prev => [...prev, ...numericPoolKeys.filter(k => !prev.includes(k))]);
    }
  }, [players, matchesByPool, matchesLoaded, generatedPoolKeys])
  
  
  

  // Update scores in state when modified
  const handleScoreChange = (poolIndex, matchIndex, teamKey, score) => {
    setMatchesByPool((prevMatches) => {
      const updated = { ...prevMatches };
      const key = poolIndex === null ? 'finales' : poolIndex;
  
      if (!updated[key]) return prevMatches;
  
      const matchToUpdate = updated[key][matchIndex];
      if (!matchToUpdate) return prevMatches;
  
      updated[key][matchIndex] = {
        ...matchToUpdate,
        [teamKey]: {
          ...matchToUpdate[teamKey],
          score,
        },
      };
      return updated;
    });
  };
  
                                                                                                                                                                                                                           
  const handleRegenerateTournament = async () => {                                                                                                                                                                          
    const typedWord = window.prompt(                                                                                                                                                                                        
      `Tu vas supprimer /tournaments/${tournamentId} avec ses poules et matchs. Ensuite il sera recréé en allant dans Visualiser le tournoi. Tape REGENERER pour confirmer.`                                                
    );                                                                                                                                                                                                                      
                                                                                                                                                                                                                            
    if (typedWord !== 'REGENERER') {                                                                                                                                                                                        
      alert('Action annulée. Tu dois taper REGENERER exactement.');                                                                                                                                                         
      return;                                                                                                                                                                                                               
    }                                                                                                                                                                                                                       
                                                                                                                                                                                                                            
    try {                                                                                                                                                                                                                   
      const collectionNames = [                                                                                                                                                                                             
        'pools',                                                                                                                                                                                                            
        'matches',                                                                                                                                                                                                          
        'matches_finales',                                                                                                                                                                                                  
        'matches_consolation',                                                                                                                                                                                              
      ];                                                                                                                                                                                                                    
                                                                                                                                                                                                                            
      for (const collectionName of collectionNames) {                                                                                                                                                                       
        const snapshot = await getDocs(                                                                                                                                                                                     
          collection(db, `tournaments/${tournamentId}/${collectionName}`)                                                                                                                                                   
        );                                                                                                                                                                                                                  
                                                                                                                                                                                                                            
        if (snapshot.empty) continue;                                                                                                                                                                                       
                                                                                                                                                                                                                            
        const batch = writeBatch(db);                                                                                                                                                                                       
                                                                                                                                                                                                                            
        snapshot.docs.forEach((document) => {                                                                                                                                                                               
          batch.delete(document.ref);                                                                                                                                                                                       
        });                                                                                                                                                                                                                 
                                                                                                                                                                                                                            
        await batch.commit();                                                                                                                                                                                               
      }                                                                                                                                                                                                                     
                                                                                                                                                                                                                            
      await deleteDoc(doc(db, 'tournaments', tournamentId));                                                                                                                                                                
                                                                                                                                                                                                                            
      setPools([]);                                                                                                                                                                                                         
      setMatchesByPool({});                                                                                                                                                                                                 
      setRankedPools([]);                                                                                                                                                                                                   
      setShowPools({});                                                                                                                                                                                                     
      setGeneratedPoolKeys([]);                                                                                                                                                                                             
      setFinalRanking([]);                                                                                                                                                                                                  
                                                                                                                                                                                                                            
      alert(                                                                                                                                                                                                                
        `Le tournoi ${tournamentId} a été supprimé avec ses poules et matchs. Va maintenant dans Visualiser le tournoi pour le recréer.`                                                                                    
      );                                                                                                                                                                                                                    
    } catch (error) {                                                                                                                                                                                                       
      console.error('Erreur suppression tournoi généré:', error);                                                                                                                                                           
      alert("Erreur lors de la suppression du tournoi généré.");                                                                                                                                                            
    }                                                                                                                                                                                                                       
  };                                

  // Save all scores to Firestore
  const handleSaveScores = async () => {
    try {
      const batch = writeBatch(db);
  
      // 📌 Références Firebase
      const pouleRef = collection(db, `tournaments/${tournamentId}/matches`);
      const finalesRef = collection(db, `tournaments/${tournamentId}/matches_finales`);
      const consolRef = collection(db, `tournaments/${tournamentId}/matches_consolation`);
  
      // 🟦 Matchs de poules
      const poolMatches = Object.entries(matchesByPool)
        .filter(([key]) => !isNaN(key))
        .flatMap(([key, matches]) =>
          matches.map((match, i) => ({
            ...match,
            phase: "poule",
            order: match.order || i,
            poolIndex: parseInt(key, 10)
          }))
        );
  
      // 🔶 Finales
      const finalMatches = matchesByPool["finales"]?.map((match, i) => ({
        ...match,
        phase: "finales",
        order: match.order || i,
        poolIndex: null,
      })) || [];
  
      // 🟨 Consolation
      const consolationMatches = matchesByPool["consolation"]?.map((match, i) => ({
        ...match,
        phase: "consolation",
        order: match.order || i,
        poolIndex: null,
      })) || [];
  
      const clean = str => str.toLowerCase().replace(/\s+/g, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  
      // 📤 Enregistrement des poules
      poolMatches.forEach((match) => {
        const matchId = match.id; // on ne génère plus rien
      
        if (!matchId) {
          console.warn("⛔ Match sans ID, impossible de l'enregistrer :", match);
          return;
        }
      
        const matchDoc = doc(pouleRef, matchId);
      
        // 🧠 Reconstituer les joueurs associés à chaque équipe
        const getPlayers = (teamName) =>
          players
            .filter(p => clean(p.teamName) === clean(teamName))
            .flatMap(p => [
              {
                prenom: p.joueur1?.prenom || '',
                nom: p.joueur1?.nom || '',
                phone: p.joueur1?.phone || '',
                elo: parseInt(p.joueur1?.elo || 700, 10),
              },
              {
                prenom: p.joueur2?.prenom || '',
                nom: p.joueur2?.nom || '',
                phone: p.joueur2?.phone || '',
                elo: parseInt(p.joueur2?.elo || 700, 10),
              },
            ]);
      
        const matchWithPlayers = {
          ...match,
          teamAPlayers: getPlayers(match.teamA.name),
          teamBPlayers: getPlayers(match.teamB.name),
        };

        
      
        batch.set(matchDoc, matchWithPlayers, { merge: true });
      });
      
      
  

      await batch.commit();
      alert('Tous les scores ont bien été enregistrés.');
      // ✅ Met à jour les ELO une seule fois par match si le match a été joué
for (const match of poolMatches) {
  const isMatchPlayed = (match.teamA.score ?? 0) !== 0 || (match.teamB.score ?? 0) !== 0;
  if (!isMatchPlayed) continue;

  try {

  } catch (err) {
    console.error(`Erreur lors de la mise à jour ELO pour le match ${match.teamA.name} vs ${match.teamB.name}`, err);
  }
}

    } catch (error) {
      console.error("Erreur lors de l\'enregistrement :", error);
    }
  };
  
  const handleSaveFinalAndConsolationScores = async () => {
    try {
      const batch = writeBatch(db);
      const finalesRef = collection(db, `tournaments/${tournamentId}/matches_finales`);
      const consolRef = collection(db, `tournaments/${tournamentId}/matches_consolation`);
  
      const clean = str => str.toLowerCase().replace(/\s+/g, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  
      // ✅ Déclaré AVANT de l’utiliser
      const getPlayers = (teamName) =>
        players
          .filter(p => clean(p.teamName) === clean(teamName))
          .flatMap(p => [
            {
              prenom: p.joueur1?.prenom || '',
              nom: p.joueur1?.nom || '',
              phone: p.joueur1?.phone || '',
              elo: parseInt(p.joueur1?.elo || 700, 10),
            },
            {
              prenom: p.joueur2?.prenom || '',
              nom: p.joueur2?.nom || '',
              phone: p.joueur2?.phone || '',
              elo: parseInt(p.joueur2?.elo || 700, 10),
            },
          ]);
  
      // 🔁 Finales
      const finalMatches = generateFinalPhaseMatches()
        .map((match, i) => ({
          ...match,
          phase: "finales",
          order: match.order || i,
          poolIndex: null,
        }))
        .filter(match =>
          (match.teamA.score ?? 0) > 0 || (match.teamB.score ?? 0) > 0
        );
  
      finalMatches.forEach(match => {
        const idTeamA = clean(match.teamA.name);
        const idTeamB = clean(match.teamB.name);
        
        const sortedTeams = [idTeamA, idTeamB].sort().join("-vs-");
        const matchId = match.id || `finales-${sortedTeams}`;
        const matchDoc = doc(finalesRef, matchId);
  
        match.teamAPlayers = getPlayers(match.teamA.name);
        match.teamBPlayers = getPlayers(match.teamB.name);
  
        batch.set(matchDoc, match, { merge: true });
      });
  
      // 🔁 Consolations
      const consolationMatches = generateConsolationMatches()
        .map((match, i) => ({
          ...match,
          phase: "consolation",
          order: match.order || i,
          poolIndex: null,
        }))
        .filter(match =>
          (match.teamA.score ?? 0) > 0 || (match.teamB.score ?? 0) > 0
        );
  
      consolationMatches.forEach(match => {
        const idTeamA = clean(match.teamA.name);
        const idTeamB = clean(match.teamB.name);
        const sortedTeams = [idTeamA, idTeamB].sort().join("-vs-");
        const matchId = match.id || `consolation-${sortedTeams}`;
        const matchDoc = doc(consolRef, matchId);
  
        match.teamAPlayers = getPlayers(match.teamA.name);
        match.teamBPlayers = getPlayers(match.teamB.name);
  
        batch.set(matchDoc, match, { merge: true });
      });
  
      await batch.commit();
      alert("Phases finales et consolations bien enregistrées !");
  
      // ✅ ELO update après enregistrement
      for (const match of [...finalMatches, ...consolationMatches]) {
        const isMatchPlayed = (match.teamA.score ?? 0) !== 0 || (match.teamB.score ?? 0) !== 0;
        if (!isMatchPlayed) continue;
  
        try {
        } catch (err) {
          console.error(`Erreur lors de la mise à jour ELO pour ${match.teamA.name} vs ${match.teamB.name}`, err);
        }
      }
  
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des phases finales/consolation :", error);
    }
  };
  
  
  
  const allFinalAndConsoScoresEntered = () => {
    const allMatches = [
      ...(matchesByPool["finales"] || []),
      ...(matchesByPool["consolation"] || [])
    ];


  
    return allMatches.length > 0 && allMatches.every(match =>
      (match.teamA?.score ?? 0) > 0 || (match.teamB?.score ?? 0) > 0
    );
  };

  

  const handleUpdateElo = async () => {
    try {

      const clean = str =>
      str?.toLowerCase().replace(/\s+/g, '').normalize("NFD").replace(/[\u0300-\u036f]/g, '');
      
      const updatedMatches = [];
  
      const allMatches = [
        ...Object.entries(matchesByPool)
          .filter(([key]) => !isNaN(key))
          .flatMap(([_, matches]) => matches.map(match => ({ ...match, phase: "poule" }))),
        ...(matchesByPool["finales"] || []).map(m => ({ ...m, phase: "finales" })),
        ...(matchesByPool["consolation"] || []).map(m => ({ ...m, phase: "consolation" })),
      ];
  
      for (const match of allMatches) {
        if (
          (match.teamA?.score ?? 0) === 0 &&
          (match.teamB?.score ?? 0) === 0
        ) continue; // Match non joué, on skippe

        
  
        if (match.eloUpdated) continue; // Déjà mis à jour

        
  
        // ⏳ Met à jour les ELO des 4 joueurs
        const getPlayers = (teamName) =>
        players
          .filter(p => clean(p.teamName) === clean(teamName))
          .flatMap(p => [
            {
              prenom: p.joueur1?.prenom || '',
              nom: p.joueur1?.nom || '',
              phone: p.joueur1?.phone || '',
              elo: parseInt(p.joueur1?.elo || 700, 10),
            },
            {
              prenom: p.joueur2?.prenom || '',
              nom: p.joueur2?.nom || '',
              phone: p.joueur2?.phone || '',
              elo: parseInt(p.joueur2?.elo || 700, 10),
            },
          ]);
      
      const matchWithPlayers = {
        ...match,
        teamAPlayers: getPlayers(match.teamA.name),
        teamBPlayers: getPlayers(match.teamB.name),
      };
      
      
      
        // 🔒 On marque comme mis à jour pour ne plus jamais recalculer
        const collectionName = {
          poule: "matches",
          finales: "matches_finales",
          consolation: "matches_consolation",
        }[match.phase] || "matches";
  
        const idTeamA = clean(match.teamA.name);
        const idTeamB = clean(match.teamB.name);
        const matchId = match.id || `${match.phase}-${[idTeamA, idTeamB].sort().join("-vs-")}`;
  
        const matchDoc = doc(db, `tournaments/${tournamentId}/${collectionName}/${matchId}`);
        await setDoc(matchDoc, { eloUpdated: true }, { merge: true });
  
        updatedMatches.push(matchId);
      }
  
      alert(`✅ ELO mis à jour pour ${updatedMatches.length} match(s).`);
    } catch (error) {
      console.error("Erreur lors de la mise à jour ELO :", error);
      alert("❌ Erreur pendant la mise à jour du classement ELO.");
    }
  };
  

  const generateFinalRanking = () => {
    const finales = matchesByPool["finales"] || [];
    const consolations = matchesByPool["consolation"] || [];
  
    const classement = [];
  
    const demi1 = finales.find(m => m.order === 0);
    const demi2 = finales.find(m => m.order === 1);
    const finale = finales.find(m => m.order === 2);
  
    if (!demi1 || !demi2 || !finale) {
      alert("Deux demi-finales (order 0 et 1) et une finale (order 2) sont nécessaires.");
      return;
    }
  
    const normalize = str =>
      str?.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  
    const winner = finale.teamA.score > finale.teamB.score ? finale.teamA.name : finale.teamB.name;
    const loser = winner === finale.teamA.name ? finale.teamB.name : finale.teamA.name;
  
    classement.push({ place: 1, team: winner });
    classement.push({ place: 2, team: loser });
  
    const finalistes = [normalize(winner), normalize(loser)];
  
    const perdantsDemi = [demi1, demi2]
      .map(match => {
        const perdant = match.teamA.score > match.teamB.score ? match.teamB : match.teamA;
        return { name: perdant.name, score: perdant.score };
      })
      .filter(p => !finalistes.includes(normalize(p.name)))
      .sort((a, b) => b.score - a.score);
  
    perdantsDemi.forEach((team, i) => {
      classement.push({ place: classement.length + 1, team: team.name });
    });
  
    const déjàClassés = new Set(classement.map(e => normalize(e.team)));
  
    // Consolations triées
    const consolationsOrdonnées = consolations
      .filter(match =>
        !déjàClassés.has(normalize(match.teamA.name)) ||
        !déjàClassés.has(normalize(match.teamB.name))
      )
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  
    consolationsOrdonnées.forEach((match) => {
      const winner = match.teamA.score > match.teamB.score ? match.teamA.name : match.teamB.name;
      const loser = winner === match.teamA.name ? match.teamB.name : match.teamA.name;
  
      if (!déjàClassés.has(normalize(winner))) {
        classement.push({ place: classement.length + 1, team: winner });
        déjàClassés.add(normalize(winner));
      }
  
      if (!déjàClassés.has(normalize(loser))) {
        classement.push({ place: classement.length + 1, team: loser });
        déjàClassés.add(normalize(loser));
      }
    });
  
    // 🔁 Ajoute toutes les équipes restantes
    const allTeams = players.map(p => p.teamName).map(normalize);
    const nonClassés = allTeams.filter(name => !déjàClassés.has(name));
  
    nonClassés.forEach(teamName => {
      const team = players.find(p => normalize(p.teamName) === teamName);
      if (team) {
        classement.push({ place: classement.length + 1, team: team.teamName });
      }
    });
  
    setFinalRanking(classement);
  };
  
  

  // Calculate rankings based on scores
  useEffect(() => {
    const calculateRankings = () => {
      const newRankedPools = pools.map((pool, poolIndex) => {
        const matches = matchesByPool[poolIndex] || [];
        const points = {};
        const matchWins = {};
        const gamesWon = {};
        const gamesLost = {};

        matches.forEach(match => {
          const { teamA, teamB } = match;

          [teamA, teamB].forEach(team => {
            if (!points[team.name]) points[team.name] = 0;
            if (!matchWins[team.name]) matchWins[team.name] = 0;
            if (!gamesWon[team.name]) gamesWon[team.name] = 0;
            if (!gamesLost[team.name]) gamesLost[team.name] = 0;
          });

          gamesWon[teamA.name] += teamA.score;
          gamesWon[teamB.name] += teamB.score;
          gamesLost[teamA.name] += teamB.score;
          gamesLost[teamB.name] += teamA.score;

          if (teamA.score > teamB.score) {
            points[teamA.name] += 3;
            matchWins[teamA.name] += 1;
          } else if (teamA.score < teamB.score) {
            points[teamB.name] += 3;
            matchWins[teamB.name] += 1;
          }
        });

        return pool.map(player => {
          const gamesDiff = (gamesWon[player.teamName] || 0) - (gamesLost[player.teamName] || 0);
          return {
            teamName: player.teamName,
            points: points[player.teamName] || 0,
            wins: matchWins[player.teamName] || 0,
            gamesWon: gamesWon[player.teamName] || 0,
            gamesLost: gamesLost[player.teamName] || 0,
            gamesDiff,
          };
        }).sort((a, b) => b.points - a.points || b.gamesDiff - a.gamesDiff);
      });

      setRankedPools(newRankedPools);
    };

    calculateRankings();
  }, [matchesByPool, pools]);

  const togglePoolVisibility = poolIndex => {
    setShowPools(prevState => ({
      ...prevState,
      [poolIndex]: !prevState[poolIndex],
    }));
  };

  if (loading) {
    return <div>Chargement...</div>;
  }

  // Génère les phases finales dynamiquement à partir des classés
  const generateFinalPhaseMatches = () => {
    const finalMatches = [];
    const existingFinales = matchesByPool['finales'] || [];
  
    if (rankedPools.length === 2) {
      if (
        rankedPools[0]?.length >= 2 &&
        rankedPools[1]?.length >= 2
      ) {
        finalMatches.push(
          generateMatch(
            rankedPools[0][0].teamName,
            rankedPools[1][1].teamName,
            null,
            "finales",
            0
          )
        );
        finalMatches.push(
          generateMatch(
            rankedPools[1][0].teamName,
            rankedPools[0][1].teamName,
            null,
            "finales",
            1
          )
        );
      }
    }
  
    if (rankedPools.length === 3 && rankedPools.every(pool => pool.length >= 2)) {
      // ✅ Nouvelle logique spécifique 12 équipes
      const p1 = rankedPools[0];
      const p2 = rankedPools[1];
      const p3 = rankedPools[2];
    
      // 🏆 Demi-finales
      finalMatches.push(generateMatch(p1[0].teamName, p3[0].teamName, null, "finales", 0)); // 1er P1 vs 1er P3
      finalMatches.push(generateMatch(p3[1].teamName, p2[0].teamName, null, "finales", 1)); // 2e P1 vs 1er P2
    }
    

    if (rankedPools.length === 4 && rankedPools.every(pool => pool.length >= 1)) {
      const p1 = rankedPools[0];
      const p2 = rankedPools[1];
      const p3 = rankedPools[2];
      const p4 = rankedPools[3];
    
      // 🏆 Demi-finales : 1er P1 vs 1er P3, et 1er P2 vs 1er P4
      finalMatches.push(generateMatch(p1[0].teamName, p3[0].teamName, null, "finales", 0));
      finalMatches.push(generateMatch(p2[0].teamName, p4[0].teamName, null, "finales", 1));
    }
    
  
    // 🧠 Injecter les scores précédents si déjà encodés
    finalMatches.forEach((match, i) => {
      const existing = existingFinales[i];
      if (existing) {
        match.teamA.score = existing.teamA?.score ?? 0;
        match.teamB.score = existing.teamB?.score ?? 0;
      }
    });
  
    // Si les deux demi-finales ont été jouées, ajouter la finale
    const [demi1, demi2] = finalMatches;

if (
  demi1?.teamA?.score != null && demi1?.teamB?.score != null &&
  demi2?.teamA?.score != null && demi2?.teamB?.score != null
) {
  const winner1 = demi1.teamA.score > demi1.teamB.score ? demi1.teamA.name : demi1.teamB.name;
  const winner2 = demi2.teamA.score > demi2.teamB.score ? demi2.teamA.name : demi2.teamB.name;

  const loser1 = winner1 === demi1.teamA.name ? demi1.teamB.name : demi1.teamA.name;
  const loser2 = winner2 === demi2.teamA.name ? demi2.teamB.name : demi2.teamA.name;

  // 🏆 Finale
  const finale = generateMatch(winner1, winner2, null, "finales", 2);
  const existingFinale = existingFinales.find(m => m.order === 2);
  if (existingFinale) {
    finale.teamA.score = existingFinale.teamA?.score ?? 0;
    finale.teamB.score = existingFinale.teamB?.score ?? 0;
  }
  finalMatches.push(finale);

  // 🥉 Petite finale
  const petiteFinale = generateMatch(loser1, loser2, null, "finales", 3);
  const existingPetiteFinale = existingFinales.find(m => m.order === 3);
  if (existingPetiteFinale) {
    petiteFinale.teamA.score = existingPetiteFinale.teamA?.score ?? 0;
    petiteFinale.teamB.score = existingPetiteFinale.teamB?.score ?? 0;
  }
  finalMatches.push(petiteFinale);
}


    
  
    return finalMatches;
  };
  
  const generateConsolationMatches = () => {
    const consolationMatches = [];
    const existingConso = matchesByPool['consolation'] || [];

    if (rankedPools.length === 4 && rankedPools.every(pool => pool.length >= 4)) {
      const p1 = rankedPools[0];
      const p2 = rankedPools[1];
      const p3 = rankedPools[2];
      const p4 = rankedPools[3];
    
      const consoPairs = [
        [p1[1], p2[1]], // 2e P1 vs 2e P2
        [p1[2], p2[2]], // 3e P1 vs 3e P2
        [p1[3], p2[3]], // 4e P1 vs 4e P2
    
        [p3[1], p4[1]], // 2e P3 vs 2e P4
        [p3[2], p4[2]], // 3e P3 vs 3e P4
        [p3[3], p4[3]], // 4e P3 vs 4e P4
      ];
    
      return consoPairs
        .filter(([a, b]) => a?.teamName && b?.teamName)
        .map(([a, b], index) => {
          const match = generateMatch(a.teamName, b.teamName, null, "consolation", index);
          const existing = existingConso.find(m =>
            (m.teamA.name === a.teamName && m.teamB.name === b.teamName) ||
            (m.teamA.name === b.teamName && m.teamB.name === a.teamName)
          );
          if (existing) {
            match.teamA.score = existing.teamA?.score ?? 0;
            match.teamB.score = existing.teamB?.score ?? 0;
          }
          return match;
        });
    }
    

    if (rankedPools.length === 3 && rankedPools.every(pool => pool.length >= 4)) {
      const p1 = rankedPools[0];
      const p2 = rankedPools[1];
      const p3 = rankedPools[2];
    
      const consoPairs = [
        [p3[2], p2[1]], // 3e P3 vs 2e P2
        [p1[1], p2[2]], // 2e P1 vs 3e P2
        [p1[2], p3[3]], // 3e P1 vs 4e P3
        [p1[3], p2[3]], // 4e P1 vs 4e P2
      ];
    
      const matches = consoPairs
        .filter(([a, b]) => a?.teamName && b?.teamName)
        .map(([a, b], index) => {
          const match = generateMatch(a.teamName, b.teamName, null, "consolation", index);
          const existing = existingConso.find(m =>
            (m.teamA.name === a.teamName && m.teamB.name === b.teamName) ||
            (m.teamA.name === b.teamName && m.teamB.name === a.teamName)
          );
          if (existing) {
            match.teamA.score = existing.teamA?.score ?? 0;
            match.teamB.score = existing.teamB?.score ?? 0;
          }
          return match;
        });
    
      return matches;
    }
    
  
    if (rankedPools.length < 2) return consolationMatches;
  
    const maxTeamCount = Math.max(...rankedPools.map(pool => pool.length));
  
    for (let i = 2; i < maxTeamCount; i++) {
      // Liste des équipes à la position i dans chaque poule
      const teamsAtRank = rankedPools
        .map((pool, poolIndex) => ({
          name: pool[i]?.teamName,
          poolIndex,
        }))
        .filter(team => team.name); // enlever undefined
    
      // ✅ Trier selon la force de la poule (1 > 2 > 3)
      teamsAtRank.sort((a, b) => a.poolIndex - b.poolIndex);
    
      // ⚠️ Créer des paires sans équipes de même poule
      const used = new Set();
    
      for (let j = 0; j < teamsAtRank.length; j++) {
        const teamA = teamsAtRank[j];
        if (!teamA || used.has(teamA.name)) continue;
    
        // Chercher un adversaire d’une autre poule
        const opponent = teamsAtRank.slice(j + 1).find(
          teamB =>
            !used.has(teamB.name) &&
            teamB.poolIndex !== teamA.poolIndex
        );
    
        if (opponent) {
          const match = generateMatch(teamA.name, opponent.name, null, "consolation", i * 10 + j);
          const existing = existingConso.find(
            m =>
              (m.teamA.name === teamA.name && m.teamB.name === opponent.name) ||
              (m.teamA.name === opponent.name && m.teamB.name === teamA.name)
          );
          if (existing) {
            match.teamA.score = existing.teamA?.score ?? 0;
            match.teamB.score = existing.teamB?.score ?? 0;
          }
    
          consolationMatches.push(match);
          used.add(teamA.name);
          used.add(opponent.name);
        }
      }
    }
    
  
    return consolationMatches;
  };
  
  
  

  return (
    <section className="container mx-auto my-16 px-4">
      <h2 className="text-3xl font-semibold text-[#4c2f8e] mb-8 text-center">
        Matchs et Classement du Tournoi {tournamentId}
      </h2>

      {players.length > 0 && (
  <div className="overflow-x-auto mb-8">
    <h3 className="text-xl font-semibold text-[#4c2f8e] mb-4">Liste des équipes inscrites</h3>
    <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
      <thead>
        <tr className="bg-[#4c2f8e] text-white">
          <th className="py-2 px-4 border-b">Équipe</th>
          <th className="py-2 px-4 border-b">Joueur 1</th>
          <th className="py-2 px-4 border-b">Numéro</th>
          <th className="py-2 px-4 border-b">Joueur 2</th>
          <th className="py-2 px-4 border-b">Numéro</th>
        </tr>
      </thead>
      <tbody>
        {players.map((player, index) => (
          <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
            <td className="py-2 px-4 border-b font-medium">{player.teamName}</td>
            <td className="py-2 px-4 border-b">{player.joueur1?.prenom} {player.joueur1?.nom}</td>
            <td className="py-2 px-4 border-b">{player.joueur1?.phone}</td>
            <td className="py-2 px-4 border-b">{player.joueur2?.prenom} {player.joueur2?.nom}</td>
            <td className="py-2 px-4 border-b">{player.joueur2?.phone}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

      <div className="text-center mt-6">
      <button                                                                                                                                                                                                                   
    onClick={handleRegenerateTournament}                                                                                                                                                                                    
    className="px-5 py-3 bg-red-600 text-white rounded-full font-black hover:bg-red-700 transition"                                                                                                                         
  >
    REGENERER                                                                                                                                                                                                               
  </button>                     
</div>

      {pools.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {pools.map((pool, poolIndex) => (
            <div key={poolIndex} className="p-6 bg-white shadow-lg rounded-xl border border-gray-200">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-semibold text-[#4c2f8e] mb-4">Poule {poolIndex + 1}</h3>
                <button onClick={() => togglePoolVisibility(poolIndex)}>
                  {showPools[poolIndex] ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>
              {showPools[poolIndex] && (
                <>
                  <div className="border-b border-gray-200 pb-4 mb-4">
                  <ul className="space-y-2">
  {pool.map((player, i) => {
    const elo1 = parseInt(player.joueur1?.elo || 700, 10);
    const elo2 = parseInt(player.joueur2?.elo || 700, 10);
    const teamElo = elo1 + elo2;

    return (

      
      <li key={i} className="text-gray-700 text-lg bg-gray-50 px-4 py-2 rounded-lg shadow-md">
        {player.teamName}{' '}
        <span className="text-sm text-gray-500">
          (Classement de l'équipe : {teamElo})
        </span>
      </li>
    );
  })}
</ul>

                  </div>
                  

                  <h4 className="text-xl font-semibold text-[#4c2f8e] mb-4">Classement de la poule</h4>
                  <ul className="space-y-4">
                    {rankedPools[poolIndex] &&
                      rankedPools[poolIndex].map((team, i) => (
                        <li key={i} className="text-lg bg-gray-100 p-4 rounded-lg shadow">
                          {team.teamName} - {team.points} P - {team.wins} V {team.gamesWon} JG {team.gamesLost} JP (Diff: {team.gamesDiff})
                        </li>
                      ))}
                  </ul>
                        
                  <h4 className="text-xl font-semibold text-[#4c2f8e] mb-4">Matchs</h4>
                  <ul className="space-y-4">
                  {matchesByPool[poolIndex] &&
  [...matchesByPool[poolIndex]]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((match, matchIndex) => (
      <MatchScore
        key={matchIndex}
        match={match}
        matchIndex={matchIndex}
        poolIndex={poolIndex}
        onScoreChange={handleScoreChange}
      />
    ))
}

                  </ul>
                </>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-600 text-center">Aucun joueur inscrit pour ce tournoi.</p>
      )}

      {Object.keys(matchesByPool).length > 0 && (
        <div className="text-center mt-8">
          <button
            onClick={handleSaveScores}
            className="px-6 py-3 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl"
          >
            Enregistrer tous les scores
          </button>
          
          {rankedPools.length >= 2 && (
  <div className="mt-12 text-center">
    <h3 className="text-2xl font-semibold text-[#4c2f8e] mb-6">Phases Finales</h3>
    <ul className="space-y-4">
    {generateFinalPhaseMatches().length > 0 && (
  <>
    <h4 className="text-xl font-semibold text-[#4c2f8e] mb-2">Demi-finales</h4>
    <ul className="space-y-4">
      {generateFinalPhaseMatches().slice(0, 2).map((match, index, list) => (
        <MatchScore
          key={`demi-${index}`}
          match={match}
          matchIndex={index}
          poolIndex={null}
          onScoreChange={(poolIdx, matchIdx, teamKey, score) => {
            const matchToUpdate = list[matchIdx];
            const phaseKey = matchToUpdate.phase || 'finales';
            setMatchesByPool(prev => {
              const updated = { ...prev };
              if (!updated[phaseKey]) updated[phaseKey] = [];
              updated[phaseKey][matchIdx] = {
                ...matchToUpdate,
                [teamKey]: {
                  ...matchToUpdate[teamKey],
                  score,
                },
              };
              return updated;
            });
          }}
        />
      ))}
    </ul>

    {generateFinalPhaseMatches().length >= 3 && (

      <>
        <h4 className="text-xl font-semibold text-[#4c2f8e] mt-8 mb-2">Finale</h4>
        <ul className="space-y-4">
          <MatchScore
            key="finale"
            match={generateFinalPhaseMatches()[2]}
            matchIndex={2}
            poolIndex={null}
            onScoreChange={(poolIdx, matchIdx, teamKey, score) => {
              const matchToUpdate = generateFinalPhaseMatches()[2];
              const phaseKey = matchToUpdate.phase || 'finales';
              setMatchesByPool(prev => {
                const updated = { ...prev };
                if (!updated[phaseKey]) updated[phaseKey] = [];
                updated[phaseKey][matchIdx] = {
                  ...matchToUpdate,
                  [teamKey]: {
                    ...matchToUpdate[teamKey],
                    score,
                  },
                };
                return updated;
              });
            }}
          />
        </ul>
      </>
    )}

<h4 className="text-xl font-semibold text-[#4c2f8e] mt-8 mb-2">Petite Finale</h4>
<ul className="space-y-4">
  <MatchScore
    key="petite-finale"
    match={generateFinalPhaseMatches()[3]}
    matchIndex={3}
    poolIndex={null}
    onScoreChange={(poolIdx, matchIdx, teamKey, score) => {
      const matchToUpdate = generateFinalPhaseMatches()[3];
      const phaseKey = matchToUpdate.phase || 'finales';
      setMatchesByPool(prev => {
        const updated = { ...prev };
        if (!updated[phaseKey]) updated[phaseKey] = [];
        updated[phaseKey][matchIdx] = {
          ...matchToUpdate,
          [teamKey]: {
            ...matchToUpdate[teamKey],
            score,
          },
        };
        return updated;
      });
    }}
  />
</ul>

  </>
)}


    </ul>
  </div>
)}



{generateConsolationMatches().length > 0 && (
  <div className="mt-16 text-center">
    <h3 className="text-2xl font-semibold text-[#4c2f8e] mb-6">Matchs de Consolation</h3>
    <ul className="space-y-4">
    {generateConsolationMatches().map((match, index, consos) => (
  <MatchScore
    key={`conso-${index}`}
    match={match}
    matchIndex={index}
    poolIndex={null}
    onScoreChange={(poolIdx, matchIdx, teamKey, score) => {
      const matchToUpdate = consos[matchIdx]; // ✅ match du bon tableau
      const phaseKey = matchToUpdate.phase || 'consolation';

      setMatchesByPool(prev => {
        const updated = { ...prev };
        if (!updated[phaseKey]) updated[phaseKey] = [];
        updated[phaseKey][matchIdx] = {
          ...matchToUpdate,
          [teamKey]: {
            ...matchToUpdate[teamKey],
            score,
          },
        };
        return updated;
      });
    }}
  />
))}

{(generateFinalPhaseMatches().length > 0 || generateConsolationMatches().length > 0) && (
  <div className="text-center mt-8">
    <button
      onClick={handleSaveFinalAndConsolationScores}
      className="px-6 py-3 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl"
    >
      Enregistrer les phases finales & consolations
    </button>

    {allFinalAndConsoScoresEntered() && (
  <div className="text-center mt-6">
    <button
      onClick={generateFinalRanking}
      className="px-6 py-3 bg-gradient-to-r from-[#4c2f8e] to-[#ea4c89] text-white rounded-full shadow-lg transform transition-all duration-300 hover:scale-110 hover:shadow-2xl"
    >
      Générer le classement final
    </button>
  </div>
)}




  </div>
  
)}


    </ul>
  </div>
)}


        </div>

        
      )}

{finalRanking.length > 0 && (
    <div className="mt-12 text-center">
      <h3 className="text-2xl font-semibold text-[#4c2f8e] mb-4">Classement Final</h3>
      <ul className="space-y-2">
        {finalRanking.map((entry, index) => (
          <li key={index} className="text-lg bg-gray-100 py-2 px-4 rounded shadow">
            {entry.place}ᵉ : {entry.team}
          </li>
        ))}
      </ul>

      
    </div>

    

    
  )}


      
    </section>

    
  );

  
  
};

export default TournamentView;
